import React from 'react';

interface ModalSubtitleProps {
  text: string;
  className?: string;
}

export default function ModalSubtitle({ text, className = '' }: ModalSubtitleProps) {
  return <p className={`text-sm font-medium text-gray-800 ${className}`}>{text}</p>;
}
